import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportLeadsMutation,
  ExportLeadsMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportLeads = graphql(`
  mutation exportLeads(
    $filters: SearchLeadsRequest!
    $exportFormat: ExportFormatArgs!
    $pagination: PaginationOptions!
    $selectedLeads: SelectedLeads!
    $selectedFields: [String!]
  ) {
    exportLeads(
      SearchLeadRequest: $filters
      ExportFormat: $exportFormat
      PaginationOptions: $pagination
      SelectedLeads: $selectedLeads
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useLeadExport(
  options?: UseMutationOptions<ExportLeadsMutation, unknown, ExportLeadsMutationVariables, unknown>,
) {
  const { data, ...rest } = useGraphQlMutation(exportLeads, options);
  return { ...rest, data: data?.exportLeads };
}
